module.exports = __webpack_public_path__ + "static/img/sino.ce11c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/sino.png
// module id = KdTl
// module chunks = 1